<template>
    <div id="vipConfirm" class="cover" @click.self="closeCover">
        <div class="vippopup-con cover_center_panel coupon_cover_panel">
            <img class="popup-bj" src="./img/vip-bar-img.png" />
            <div class="text" v-if="from < 2">
                <div class="no-vip-tel">提示</div>
                <div class="no-vip-text" v-if="from == 0">您的次数已用尽，开通会员畅享无限对话</div>
                <div class="no-vip-text" v-if="from == 1">下载、截图功能仅限会员使用，开通会员畅享无限对话</div>
                <div class="open-btns" @click="openVip">开通会员</div>
            </div>
            <div class="text" v-if="from == 2">
                <div class="no-vip-tel">提示</div>
                <div class="no-vip-text">您的字数包已用完，请去充值字数包畅享4.0对话</div>
                <div class="open-btns" @click="openVip">立即去充值字数包</div>
            </div>
            <div class="text" v-if="from == 3">
                <div class="no-vip-tel">提示</div>
                <div class="no-vip-text">对不起，您还不是会员和没有绘画体验包，请先开通会员</div>
                <div class="open-btns" @click="openVip">开通会员</div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        props: ['from'],
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            closeCover(){
                this.$emit('confirm',false)
            },
			openVip(){
				this.$emit("confirm",true)
			}
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .vippopup-con{
		width: 350px;
		position: relative;
        background-color: transparent;
		.popup-bj{
			width: 100%;
			height: 175px;
            display: block;
		}
		.text{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			.no-vip-tel{
                text-align: center;
                padding-top: 15px;
                color: #fff;
                font-size: 16px;
			}
			.no-vip-text{
				text-align: center;
                padding: 21px 20px 4px ;
                color: #fff;
                font-size: 15px;
			}
			.open-btns{
                margin: 17px 45px 0px 45px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: linear-gradient(180deg,#ffe3bc,#ffc06b);
                border-radius: 25px;
                color: #714c1b;
                font-size: 15px;
                font-weight: 700;
                cursor: pointer;
                user-select: none;
			}
		}
	}
</style>